import { useI18nContext } from "@hopper-b2b/i18n";

/**
 * Startup surface rendered in place of the transcript while Assist connects,
 * shared by the floating widget and the standalone webview page.
 */
export const HtsAssistLoadingMessage: React.FC = () => {
  const { t } = useI18nContext();

  return (
    <div className="hts-assist-chat-loading">
      {t("chat.htsAssistLoadingText")}
    </div>
  );
};
